import React from "react";
import { Link } from "react-router-dom";
import { URL_INFURA, cortador } from "../helpers";
import ShowTotalCart from "./ShowTotalCart";

const styles = {
  title: {
    textAlign: "center",
    fontWeight: "200",
  },
  Glabels: {
    display: "flex",
    marginTop: "35px",
    paddingBottom: "20px",
    borderBottom: "1px solid #DDD",
  },
  first: {
    width: "50%",
    display: "flex",
  },
  labels: {
    width: "50%",
    display: "flex",
    justifyContent: "space-between",
    textAlign: "center",
  },
  labelsStyle: {
    fontSize: ".8rem",
    textAlign: "center",
  },
  subtotal: {
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
  },
  button: {
    marginTop: "20px",
    marginLeft: "5px",
    border: "1px solid #222",
    padding: "20px 15px",
    backgroundColor: "#FFF",
    color: "#222",
    textTransform: "uppercase",
  },
  input: {
    border: "1px solid #DDD",
    width: "100px",
    height: "40px",
  },
  backG:{
    color: "#FFF",
    backgroundColor:"#C00",
    marginTop: "20px",
    marginLeft: "5px",
    border: "1px solid #C00",
    padding: "20px 15px",
    textTransform: "uppercase",
  }
};
export default function ViewCart({ carrito, removeFromCart, updateCart }) {
  return (
    <div>
      <h1 style={styles.title}>Your Cart</h1>
      <div>
        <div style={styles.Glabels}>
          <div style={styles.first}></div>
          <div style={styles.labels}>
            <div style={styles.labelsStyle}>PRICE</div>
            <div style={styles.labelsStyle}>QUANTITY</div>
            <div style={styles.labelsStyle}>TOTAL</div>
          </div>
        </div>

        { carrito.length> 0 ? carrito.map((p) => (
          <div style={styles.Glabels}>
            <div style={styles.first}>
              <img
                with="100"
                height="120"
                src={`${URL_INFURA}${p.url_image_1}`}
                alt={p.title}
              />
              <h4 style={{ paddingLeft: "20px" }}>{p.title}
              <br/>
              <button onClick={() => removeFromCart(p.id)}>Remover</button>
              </h4>
            </div>

            <div style={styles.labels}>
              <div style={styles.labelsStyle}>${p.price}</div>
              <div style={styles.labelsStyle}>
                <input
                  id={p.id}
                  onChange={(e) => {
                    //console.log(e.target.value)
                    document.getElementById(p.id).value = e.target.value;
                    updateCart(p.id, e.target.value)
                  }}
                  style={styles.input}
                  type="number"
                  min="1"
                  placeholder={p.cantidad}
                />
              </div>
              <div style={styles.labelsStyle}>${p.price * p.cantidad}</div>
            </div>
          </div>
        )): (<h3>Your cart is empty...</h3>)}

        <div style={styles.subtotal}>
          <div style={{ float: "right", display: "flex" }}>
            Subtotal:&nbsp;&nbsp;
            <ShowTotalCart carrito={carrito} />
          </div>
          <div style={{ marginTop: "10px", fontWeight: "200" }}>
            <i>Tax included and shipping calculated at checkout</i>
          </div>
        </div>

        <div style={styles.buttons}>
          <button style={styles.button}>
            <Link to="/">Continue Shopping</Link>
          </button>
          <button style={styles.backG} >
            <Link to="/checkout">Check out</Link>
          </button>
        </div>
      </div>
    </div>
  );
}
